<template>
  <div id="format">
    <Breadcrumb />
    <p class="sub-title prl70">Select Format</p>
    <div class="content middle collect mb50">
      <div class="cell">
        <!--  Start -->
        <div>
          <div class="container font14 dflex"
            :class="{ fcolumn: $store.getters.isVertical, frow: !$store.getters.isVertical }"
          >
            <div class="row">
              <div class="col-xs-12 text-center mt30 inlineb mb30">
                <div class="inlineb p10 w100">
                  <div ref="printMe" class="inlineb">
                    <AlbaPanel v-if="type == 'alba'" />
                    <AriaPanel v-else-if="type == 'aria'" />
                    <AxesPanel v-else-if="type == 'axes'" />
                    <BlackJackPanel v-else-if="type == 'blackjack'" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row prl70" :class="{ pt100: $store.getters.isVertical }">
              <div class="col-xs-12 text-center" >
                  <el-radio 
                    :class="'format format-'+item.label"
                    v-for="item in formatSet[type]" :key="item.label"
                    v-model="format"
                    :label="item.label"
                  >
                    <div class="mlr20 inlineb">
                      <div class="border inlineb svgb">
                        <i class="iconfont3" :class="item.img"></i>
                        <!-- <img class="radio-side font20 click" :src="item.img"/> -->
                      </div>
                      <p class="name-f">
                        {{ item.title }}
                      </p>
                    </div>
                  </el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-footer mywhite font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import AlbaPanel from "./Panel/AlbaPanel";
import AriaPanel from "./Panel/AriaPanel";
import AxesPanel from "./Panel/AxesPanel";
import BlackJackPanel from "./Panel/BlackJackPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";

export default {
  name: "s2",
  components: {
    Breadcrumb,
    AlbaPanel,
    AriaPanel,
    AxesPanel,
    BlackJackPanel
  },
  mixins: [artworkToProductMixin],
  data() {
    return {
      type: null,
      defaultLayout: {
        axes: "N34",
        alba: "BB",
        aria: "L12",
        blackjack: "BB"
      },
      defaultLeftButtonLayout: {
        axes: "N34",
        alba: "B",
        aria: "L12",
        blackjack: "B"
      },
      formatSet: {
        alba: [
          { label: "single", title: "Single Frame", img: "icon-alba-of" },
          { label: "double", title: "Double Frame", img: "icon-alba-df" },
          { label: "triple", title: "Triple Frame", img: "icon-alba-tf" },
          {
            label: "vdouble",
            title: "Vertical Double Frame",
            img: "icon-alba-vd",
          },
          {
            label: "vtriple",
            title: "Vertical Triple Frame",
            img: "icon-alba-vt",
          },
        ],
        aria: [
          { label: "single", title: "Single Frame", img: "icon-aria-sf" },
          { label: "double", title: "Double Frame", img: "icon-aria-df" },
          { label: "triple", title: "Triple Frame", img: "icon-aria-tf" },
          {
            label: "vdouble",
            title: "Vertical Double Frame",
            img: "icon-aria-vd",
          },
          {
            label: "vtriple",
            title: "Vertical Triple Frame",
            img: "icon-aria-vt",
          },
        ],
        axes: [
          { label: "single", title: "Single Frame", img: "icon-axes-sf" },
          { label: "double", title: "Double Frame", img: "icon-axes-df" },
          // { label: "triple", title: "Triple Frame", img: "icon-aria-tf" },
          {
            label: "vdouble",
            title: "Vertical Double Frame",
            img: "icon-axes-vd",
          },
          /* {
            label: "vtriple",
            title: "Vertical Triple Frame",
            img: "icon-axes-vt",
          }, */
        ],
        blackjack: [
          { label: "single", title: "Single Frame", img: "icon-bj-k4-square" },
          { label: "double", title: "Double Frame", img: "icon-bj-df" },
          { label: "triple", title: "Triple Frame", img: "icon-bj-tf" },
          {
            label: "vdouble",
            title: "Vertical Double Frame",
            img: "icon-bj-vd",
          },
          {
            label: "vtriple",
            title: "Vertical Triple Frame",
            img: "icon-bj-vt",
          },
        ],
      },
    };
  },

  methods: {
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },

    next() {
      this.$store.commit("getProductCode");
      if (this.$store.state.artwork.layout == "SK") {
        this.$store.state.artwork.layout = Object.keys(
          this.$store.state.styleMap[this.$store.state.artwork.type]
        )[0];
        this.$store.state.artwork.layoutStyle = "iconOnly";
        this.$store.commit("getContent");
      }
      if (
        this.$store.getters.isTriple &&
        this.$store.state.artwork.tripleRightLayout != "SK"
      ) {
        this.$store.state.artwork.tripleRightLayout = "SK";
        this.$store.state.artwork.tripleRightLayoutStyle = "socket";
        this.$store.commit("getTripleRightContent");
      }
      //Go to next page
      if (this.type == "blackjack") {
        this.$router.push({ path: "/collection/button-format/" + this.routeParamArtworkId});  
      } else {
        this.$router.push({ path: "/collection/product/" + this.routeParamArtworkId});
      }
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({ path: "/collection/config/" + this.routeParamArtworkId});
    },
  },

  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }
    this.$parent.headerB();
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 3;
    //read from store
    this.type = this.$store.state.artwork.type;
  },
  watch: {
    format(newVal) {
      if (newVal == "double" || newVal == "vdouble") {
        if (this.$store.state.artwork.rightSideLeftButton === null) {
          this.$store.state.artwork.rightSideLeftButton = 'M1';
          this.$store.commit("getRightContent");
        }

        if (
          this.$store.state.artwork.layout == "CH" ||
          this.$store.state.artwork.layout == "CR" ||
          this.$store.state.artwork.layout == "DR"
        ) {
          this.$store.state.artwork.layout = "N34";
          this.$store.state.artwork.leftSideLeftButton = "N34";
          this.$store.state.artwork.layoutStyle = "iconOnly";
          this.$store.commit("getContent");
        } else if (
          this.$store.state.artwork.layout == "SK" &&
          this.$store.state.artwork.rightLayout == "SK"
        ) {
          this.$store.state.artwork.layout = this.defaultLayout[this.type];
          this.$store.state.artwork.leftSideLeftButton = this.defaultLeftButtonLayout[this.type];
          this.$store.state.artwork.leftSideRightButton = this.defaultLeftButtonLayout[this.type];
          this.$store.state.artwork.layoutStyle = "iconOnly";
          this.$store.commit("getContent");
        }
      } else if (
        newVal == "single" &&
        this.$store.state.artwork.layout == "SK"
      ) {
        this.$store.state.artwork.layout = this.defaultLayout[this.type];
        this.$store.state.artwork.leftSideLeftButton = this.defaultLeftButtonLayout[this.type];
          this.$store.state.artwork.leftSideRightButton = this.defaultLeftButtonLayout[this.type];
        this.$store.state.artwork.layoutStyle = "iconOnly";
        this.$store.commit("getContent");
      } else if (newVal == "triple" || newVal == "vtriple") {
        this.$store.state.artwork.layout = this.defaultLayout[this.type];
        this.$store.state.artwork.leftSideLeftButton = this.defaultLeftButtonLayout[this.type];
        this.$store.state.artwork.leftSideRightButton = this.defaultLeftButtonLayout[this.type];
        this.$store.state.artwork.layoutStyle = "iconOnly";
        this.$store.state.artwork.rightLayout = "SK";
        this.$store.state.artwork.rightLayoutStyle = "socket";
        this.$store.state.artwork.rightSideLeftButton = 'SK';
        this.$store.state.artwork.rightSideRightButton = null;
        this.$store.state.artwork.tripleRightLayout = "SK";
        this.$store.state.artwork.tripleRightLayoutStyle = "socket";
        this.$store.state.artwork.tripleRightSideLeftButton = 'SK';
          this.$store.state.artwork.tripleRightSideRightButton = null;
        this.$store.commit("getContent");
        this.$store.commit("getRightContent");
        this.$store.commit("getTripleRightContent");
      }
    },
  },
  computed: {
    format: {
      get: function () {
        return this.$store.state.artwork.format;
      },
      set: function (newValue) {
        this.$store.state.artwork.format = newValue;
      },
    },
  },
};
</script>

<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
